import { render, staticRenderFns } from "./Erros.vue?vue&type=template&id=50def956"
import script from "./Erros.vue?vue&type=script&lang=ts"
export * from "./Erros.vue?vue&type=script&lang=ts"
import style0 from "./Erros.vue?vue&type=style&index=0&id=50def956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports